


















































































import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import { PageTitle, MessageSpecialSituation } from '../../common/components';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import services from '../../services';
import { AdressInfo } from './viewModel';
import lang from '../../common/lang/de';

const { UserService } = services;

export default (Vue as VueConstructor<Vue & {
  $ref: {},
}>).extend({
  components: {
    PageTitle,
    MessageSpecialSituation
  },
  data() {
    return ({
      debtorNumber: '' as string,
      addressInfo: {} as AdressInfo,
      welcomeTextHeader: lang.welcome.header,
      welcomeTextSubHeader: lang.welcome.subHeader,
      listTitle: lang.welcome.listTitle,
      listSubtitle: lang.welcome.listSubtitle,
      items: [
        {
          button: 'add',
          title: lang.welcome.menu.newSupport.title,
          subtitle: lang.welcome.menu.newSupport.subtitle,
        },
        { divider: true, inset: true },
        {
          button: 'open_in_browser',
          title: lang.welcome.menu.openCase.title,
          subtitle: lang.welcome.menu.openCase.subtitle,
        },
        { divider: true, inset: true },
        {
          button: 'archive',
          title: lang.welcome.menu.closeCase.title,
          subtitle: lang.welcome.menu.closeCase.subtitle,
        },
        { divider: true, inset: true },
      ]
    });
  },
  created() {
    this.debtorNumber = this.$route.params.debtorNumber || this.$store.getters['user/getDebtorNumber'];
    this.getAddressInfo();
  },
  methods: {
    goTo(index: number) {
      if (index === 0) {
        this.$router.push({
          name: 'TermsOfUse',
          params: {
            id: this.debtorNumber,
          },
        });
      } else if (index === 2) {
        this.$router.push({
          name: 'OpenCases',
          params: {
            id: this.debtorNumber,
          },
        });
      } else if (index === 4) {
        this.$router.push({
          name: 'CloseCases',
          params: {
            id: this.debtorNumber,
          },
        });
      }
    },
    getAddressInfo() {
      UserService.getAddressInfo(this.debtorNumber).then((result: AxiosResponse<string>) => {
        const arrayResult = result.data.split('\n');
        this.addressInfo = {
          name: arrayResult[0],
          subname: arrayResult[1],
          street: arrayResult[2],
          zipAndPlace: arrayResult[3],
        };
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
